let count = 0;

export function createSpot(x, y, z, material, action, parent = "scene") {
  const id = `spot-${count++}`;
  return {
    id,
    object3D: id,
    sprite: {},
    material,
    parent,
    transform: {
      rotation: [1, 1, 0],
      scale: [120, 120, 120],
      position: [x, y, z],
    },
    interaction: {
      clickable: true,
      // hoverable: true,
      clickAction: {
        ...action,
      },
    },
  };
}

export function createTopicSpot(
  topic,
  parent = "scene",
  scale = 120,
  material = "M_Spot"
) {
  const id = `spot-${count++}`;
  return createTopicSpotWithId(id, topic, parent, scale, material);
}

export function createTopicSpotWithId(
  id,
  topic,
  parent = "scene",
  scale = 120,
  material = "M_Spot"
) {
  const action = {
    type: "context/toggleTopic",
    payload: topic,
  };

  const transformDecorator = {};

  if (Array.isArray(parent)) {
    transformDecorator.position = parent;
  }

  return {
    id,
    object3D: id,
    sprite: {},
    materialSwitch: {
      condition: "{context.tractor.state.topic}",
      defaultValue: material,
      cases: [{ key: topic, value: `${material}_Active` }],
    },
    parent: Array.isArray(parent) ? "scene" : parent,
    transform: {
      scale: [scale, scale, scale],
      ...transformDecorator,
    },
    interaction: {
      clickable: true,
      // hoverable: true,
      clickAction: {
        ...action,
      },
    },
  };
}

export function createToggleSpot(property, parent = "scene", scale = 0.12) {
  const id = `spot-${count++}`;

  const action = {
    type: "context/toggleValue",
    payload: {
      path: `tractor/${property}`,
      value: true,
    },
  };

  const transformDecorator = {};

  if (Array.isArray(parent)) {
    transformDecorator.position = parent;
  }

  return {
    id,
    object3D: id,
    sprite: {},
    materialSwitch: {
      condition: `{context.tractor.state.${property}}`,
      defaultValue: "M_Spot_Toggle",
      cases: [{ key: true, value: "M_Spot_Toggle_Active" }],
    },
    parent: Array.isArray(parent) ? "scene" : parent,
    transform: {
      scale: [scale, scale, scale],
      ...transformDecorator,
    },
    interaction: {
      clickable: true,
      // hoverable: true,
      clickAction: {
        ...action,
      },
    },
  };
}

export function createActionSpot(property, parent = "scene", scale = 0.12) {
  const id = `spot-${count++}`;
  return createActionSpotWithId(id, property, parent, scale);
}

export function createActionSpotWithId(
  id,
  property,
  parent = "scene",
  scale = 0.12
) {
  const action = {
    type: "context/toggleValue",
    payload: {
      path: `tractor/${property}`,
      value: true,
    },
  };

  const transformDecorator = {};

  if (Array.isArray(parent)) {
    transformDecorator.position = parent;
  }

  return {
    id,
    object3D: id,
    sprite: {},
    material: "M_Spot_Action",
    parent: Array.isArray(parent) ? "scene" : parent,
    transform: {
      scale: [scale, scale, scale],
      ...transformDecorator,
    },
    interaction: {
      clickable: true,
      // hoverable: true,
      clickAction: {
        ...action,
      },
    },
  };
}
